module.exports = __webpack_public_path__ + "static/img/index_new.239f844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_new.png
// module id = ljSx
// module chunks = 1